import CheckCircleOutlineRoundedIcon from '@mui/icons-material/CheckCircleOutlineRounded';
import ErrorOutlineRoundedIcon from '@mui/icons-material/ErrorOutlineRounded';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import { Box, Button, Stack, Typography } from '@mui/material';
import { BackLink } from '~/components/back-link/back-link';
import config from '~/config';
import { colors } from '~/theme';
import { getReportWhatsAppMessage, getResultCopy, ResultSubject, ResultVariant } from './result.copy';

interface ResultScreenProps {
  variant: ResultVariant;
  subject: ResultSubject;
  onNewValidation: () => void;
}

export const ResultScreen = ({ variant, subject, onNewValidation }: ResultScreenProps) => {
  const copy = getResultCopy(variant, subject);
  const isSuccess = variant === 'success';
  const foreground = isSuccess ? colors.success.text : colors.error.text;
  const background = isSuccess ? colors.success.background : colors.error.background;
  const Icon = isSuccess ? CheckCircleOutlineRoundedIcon : ErrorOutlineRoundedIcon;
  const [messageBefore, messageAfter] = copy.message.split(copy.highlight);

  return (
    <Stack spacing={3} px={3} py={4}>
      <BackLink />

      <Stack direction="row" spacing={1.5} p={2} borderRadius={2} sx={{ backgroundColor: background }}>
        <Icon sx={{ color: foreground }} />
        <Stack spacing={0.5}>
          <Typography variant="body1" fontWeight={700} sx={{ color: foreground }}>
            {copy.title}
          </Typography>
          <Typography variant="body2" sx={{ color: foreground }}>
            {messageBefore}
            <Box component="span" fontWeight={700}>
              {copy.highlight}
            </Box>
            {messageAfter}
          </Typography>
        </Stack>
      </Stack>

      <Stack spacing={2}>
        {!isSuccess && (
          <Button
            variant="contained"
            size="large"
            fullWidth
            startIcon={<WhatsAppIcon />}
            href={`${config.CUB_WHATSAPP_BASE_URL}&text=${encodeURIComponent(getReportWhatsAppMessage(subject))}`}
          >
            REPORTAR
          </Button>
        )}
        <Button variant={isSuccess ? 'contained' : 'outlined'} size="large" fullWidth onClick={onNewValidation}>
          NOVA VALIDAÇÃO
        </Button>
      </Stack>
    </Stack>
  );
};
